import React from 'react';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';
import { PageEvents } from 'shared/services/tracking';

import { CompletedTasks } from './components/completed-tasks';
import { PageTopBar } from './components/page-top-bar';
import { TasksOverview } from './components/tasks-overview';
import * as Styled from './tag.style';

export const TagDetail: React.FC = () => {
  useTrackPageVisitEvent(PageEvents.TagDetail, undefined);

  return (
    <Styled.Container>
      <Styled.Main>
        <Styled.MainContent>
          <PageTopBar />
          <TasksOverview />
          <CompletedTasks />
        </Styled.MainContent>
      </Styled.Main>
    </Styled.Container>
  );
};
